export const tests = [
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yilsdfasdfasdfsd 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8aasdfasdfa - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 asdfasdf- dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 -asdfasdfsafasdfasdfasdfasfasdf dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - asdfasdfdsafdekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - asdfasfdekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi kasdfasdfasdfonstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - asdfasdfadekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - asdfasdfdekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31sda - adsdekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 3asdfas1 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
    {
        title:"O'zbekiston respublikasi konstitutsiyasi qachon qabul qilingan?",
        variants:[
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1991-yil 8 - dekabrda",
                isTrue: true
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            },
            {
                title:"1990-yil 31 - dekabrda",
                isTrue:false
            }
        ]
    },
]